import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { PermissionsService } from '@core/permissions/services/permissions.service';

export const AdministrationGuard: CanActivateFn = () => {
  const permissionsService = inject(PermissionsService);
  return permissionsService.hasAdministrationAccess();
};
